import { Action } from "../actions/types"
import { OpeningBalanceType, OpeningBalanceActionList } from "../actions/openingBalanceActions"

const initialValue: Array<OpeningBalanceType> = []

const openingBalanceReducer = (state: Array<OpeningBalanceType> = initialValue, action: Action) => {
    switch (action.type) {

        case OpeningBalanceActionList.ADD_OPENING_BALANCE:
            return [
                ...state,
                action.data,
            ]

        case OpeningBalanceActionList.UPDATE_OPENING_BALANCE:
            const updated = [...state].slice()
            const index = updated.findIndex(u => u.id === action.data.id)

            if (index > -1) {
                updated[index] = {
                    ...action.data
                }
            }

            return updated

        case OpeningBalanceActionList.FETCH_OPENING_BALANCE:
            return action.data

        case OpeningBalanceActionList.DELETE_OPENING_BALANCE:
            return state.filter(s => s.id !== action.data)

        default:
            return state
    }
}

export default openingBalanceReducer